"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SpeechSynthesisVoice = exports.SpeechSynthesisUtterance = exports.SpeechSynthesisEvent = exports.speechSynthesis = void 0;

var _eventTargetShim = _interopRequireWildcard(require("../external/event-target-shim"));

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};

  if (obj != null) {
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

var SpeechSynthesisEvent = /*#__PURE__*/function () {
  function SpeechSynthesisEvent(type, utterance) {
    _classCallCheck(this, SpeechSynthesisEvent);

    this._type = type;
    this._utterance = utterance;
  }

  _createClass(SpeechSynthesisEvent, [{
    key: "charIndex",
    get: function get() {
      return 0;
    }
  }, {
    key: "elapsedTime",
    get: function get() {
      return 0;
    }
  }, {
    key: "name",
    get: function get() {}
  }, {
    key: "type",
    get: function get() {
      return this._type;
    }
  }, {
    key: "utterance",
    get: function get() {
      return this._utterance;
    }
  }]);

  return SpeechSynthesisEvent;
}();

exports.SpeechSynthesisEvent = SpeechSynthesisEvent;

var SpeechSynthesisUtterance = /*#__PURE__*/function (_EventTarget) {
  _inherits(SpeechSynthesisUtterance, _EventTarget);

  function SpeechSynthesisUtterance(text) {
    var _this;

    _classCallCheck(this, SpeechSynthesisUtterance);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SpeechSynthesisUtterance).call(this));
    _this._lang = 'en-US';
    _this._pitch = 1;
    _this._rate = 1;
    _this._text = text;
    _this._voice = null;
    _this._volume = 1;
    return _this;
  }

  _createClass(SpeechSynthesisUtterance, [{
    key: "lang",
    get: function get() {
      return this._lang;
    },
    set: function set(value) {
      this._lang = value;
    }
  }, {
    key: "pitch",
    get: function get() {
      return this._pitch;
    },
    set: function set(value) {
      this._pitch = value;
    }
  }, {
    key: "rate",
    get: function get() {
      return this._rate;
    },
    set: function set(value) {
      this._rate = value;
    }
  }, {
    key: "text",
    get: function get() {
      return this._text;
    },
    set: function set(value) {
      this._text = value;
    }
  }, {
    key: "voice",
    get: function get() {
      return this._voice;
    },
    set: function set(value) {
      this._voice = value;
    }
  }, {
    key: "volume",
    get: function get() {
      return this._volume;
    },
    set: function set(value) {
      this._volume = value;
    }
  }]);

  return SpeechSynthesisUtterance;
}(_eventTargetShim.default);

exports.SpeechSynthesisUtterance = SpeechSynthesisUtterance;
(0, _eventTargetShim.defineEventAttribute)(SpeechSynthesisUtterance.prototype, 'boundary');
(0, _eventTargetShim.defineEventAttribute)(SpeechSynthesisUtterance.prototype, 'end');
(0, _eventTargetShim.defineEventAttribute)(SpeechSynthesisUtterance.prototype, 'error');
(0, _eventTargetShim.defineEventAttribute)(SpeechSynthesisUtterance.prototype, 'mark');
(0, _eventTargetShim.defineEventAttribute)(SpeechSynthesisUtterance.prototype, 'pause');
(0, _eventTargetShim.defineEventAttribute)(SpeechSynthesisUtterance.prototype, 'resume');
(0, _eventTargetShim.defineEventAttribute)(SpeechSynthesisUtterance.prototype, 'start');

var SpeechSynthesisVoice = /*#__PURE__*/function () {
  function SpeechSynthesisVoice() {
    _classCallCheck(this, SpeechSynthesisVoice);
  }

  _createClass(SpeechSynthesisVoice, [{
    key: "default",
    get: function get() {
      return true;
    }
  }, {
    key: "lang",
    get: function get() {
      return 'en-US';
    }
  }, {
    key: "localService",
    get: function get() {
      return true;
    }
  }, {
    key: "name",
    get: function get() {
      return 'English (US)';
    }
  }, {
    key: "voiceURI",
    get: function get() {
      return 'English (US)';
    }
  }]);

  return SpeechSynthesisVoice;
}();

exports.SpeechSynthesisVoice = SpeechSynthesisVoice;

var SpeechSynthesis = /*#__PURE__*/function (_EventTarget2) {
  _inherits(SpeechSynthesis, _EventTarget2);

  function SpeechSynthesis() {
    _classCallCheck(this, SpeechSynthesis);

    return _possibleConstructorReturn(this, _getPrototypeOf(SpeechSynthesis).apply(this, arguments));
  }

  _createClass(SpeechSynthesis, [{
    key: "cancel",
    value: function cancel() {}
  }, {
    key: "getVoices",
    value: function getVoices() {
      return [new SpeechSynthesisVoice()];
    }
  }, {
    key: "pause",
    value: function pause() {
      throw new Error('pause is not implemented.');
    }
  }, {
    key: "resume",
    value: function resume() {
      throw new Error('resume is not implemented.');
    }
  }, {
    key: "speak",
    value: function speak(utterance) {
      utterance.dispatchEvent(new SpeechSynthesisEvent('start', utterance));
      utterance.dispatchEvent(new SpeechSynthesisEvent('end', utterance));
    }
  }, {
    key: "paused",
    get: function get() {
      return false;
    }
  }, {
    key: "pending",
    get: function get() {
      return false;
    }
  }, {
    key: "speaking",
    get: function get() {
      return false;
    }
  }]);

  return SpeechSynthesis;
}(_eventTargetShim.default);

(0, _eventTargetShim.defineEventAttribute)(SpeechSynthesis.prototype, 'voiceschanged');
var speechSynthesis = new SpeechSynthesis();
exports.speechSynthesis = speechSynthesis;